<template>
  <div class="technical-restriction" :class="{ '--alt-w': altW }">
    <header class="technical-restriction-header">
      <img :src="BASE_URL + '/img/logo_row_text.svg'" class="technical-restriction__logo" alt="logotype" />
    </header>

    <div class="technical-restriction-body">
      <slot />
    </div>

    <footer class="technical-restriction-footer">
      <p class="technical-restriction__rights">{{ footerText }}</p>
      <p v-if="!altW" class="technical-restriction__version">version {{ appVersion }}</p>
    </footer>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { storeToRefs } from 'pinia'
import { useSiteInfoStore } from 'stores/site-info'
import { useSystemStore } from 'stores/system'
import { BASE_URL } from 'src/common/config'
import { getConfig } from '@/configs/index.js'

const { t } = useI18n()
const config = getConfig()

const siteInfoStore = useSiteInfoStore()

const isWebView = siteInfoStore.isWebView

const { release, altW } = storeToRefs(useSystemStore())

const footerText = computed(() => `© ${new Date().getFullYear()} ${config.title}. ${t('all_right')}`)
const appVersion = computed(() => (isWebView ? localStorage.getItem('appVersion') : release.value))
</script>

<style scoped lang="scss">
.technical-restriction {
  display: flex;
  flex-direction: column;
  height: 100vh;
  @supports (height: 100dvh) {
    height: 100dvh;
  }

  &.--alt-w {
    .technical-restriction__logo {
      height: 32px;
    }

    @media (min-width: 768px) {
      margin: 0 52px;
    }

    .technical-restriction-footer {
      padding: 24px 12px;
      margin: 0;
    }
  }
}

.technical-restriction-header {
  padding: 24px 12px;
  flex-shrink: 0;
  line-height: normal;
  display: flex;
  justify-content: center;
}

.technical-restriction-footer {
  text-align: center;
  padding: 40px 12px 24px 12px;
  margin-top: 24px;
  flex-shrink: 0;
}

.technical-restriction__logo {
  height: 28px;
}

.technical-restriction__rights {
  color: var(--color-text-tertiary);
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
}

.technical-restriction__version {
  color: var(--color-text-fourth);
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  margin-top: 12px;
}

.technical-restriction-body {
  padding: 24px 0;
  margin: 0 12px;
  flex: 1 1;
  border-top: 1px solid var(--color-border-primary);
  border-bottom: 1px solid var(--color-border-primary);
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  @media (min-width: 768px) {
    padding: 64px 0;
    margin: 0 16px;
  }
}
</style>
